import { ReactComponent as ChevroneIcon } from '@Icons/additional/chevron-right.svg';
import styles from './card.module.css';

interface CardProps {
  unitName: string;
  qty: number;
  description: string;
  no: string | number;
  onClick: () => void;
}

const Card = ({
  description,
  no,
  qty,
  unitName,
  onClick,
}: CardProps): JSX.Element | null => {
  return (
    <div className={styles.card} onClick={onClick}>
      <div className={styles.cardManageSection}>
        <div className={styles.cardType}>
          <div className={styles.cardCaption}>Material No. {no}</div>
          <div className={styles.cardDescription}>{description}</div>
        </div>
        <div className={styles.cardChevrone}>
          <ChevroneIcon />
        </div>
      </div>
      <div className={styles.cardInfoSection}>
        <div className={styles.cardInfoType}>
          <span>Unit</span>
          <span className={unitName.length > 10 ? styles.textOverflow : ''}>
            {unitName}
          </span>
        </div>
        <div className={styles.cardInfoType}>
          <span>Required Quantity</span>
          <span>{qty}</span>
        </div>
      </div>
    </div>
  );
};

export default Card;
